import { apolloClient } from '../vue-apollo';
import tours from './tours';
import { UserRoleSettings } from '../utils/user-role';

const roleSettings = new UserRoleSettings();

// Tours this user is allowed to see (role / permission), newest first
export function toursForCurrentUser() {
  let role = null;
  try {
    role = localStorage.getItem('DONE_USER_ROLE');
  } catch (e) {
    // no storage: fall through with no role
  }
  return tours.filter((tour) => {
    if (tour.roles && tour.roles.length && !tour.roles.includes(role)) return false;
    if (tour.permission) {
      const anyOf = [].concat(tour.permission);
      if (!anyOf.some((permission) => roleSettings.hasRole(permission))) return false;
    }
    return true;
  });
}

// Whether the tenant has tours switched on, and the tours released after the
// user joined that they have not been shown yet. Resolves to disabled on any
// failure: a missed tour is better than a broken login.
export async function loadPendingTours() {
  try {
    const { data } = await apolloClient.query({
      query: require('./api/getFeatureTourState.graphql'),
      fetchPolicy: 'network-only',
    });
    const state = data && data.getFeatureTourState;
    if (!state || state.enabled === false) return { enabled: false, tours: [] };
    const seen = state.seenFeatureTours || [];
    const joined = state.createdAt ? new Date(state.createdAt) : null;
    const tours = toursForCurrentUser().filter((tour) => {
      if (seen.includes(tour.id)) return false;
      // compare whole days so a tour released on the sign-up day still shows
      if (joined && new Date(tour.releasedAt + 'T23:59:59') < joined) return false;
      return true;
    });
    return { enabled: true, tours };
  } catch (error) {
    console.debug('Failed to load feature tours:', error.message);
    return { enabled: false, tours: [] };
  }
}

export async function markToursSeen(ids) {
  if (!ids || !ids.length) return;
  try {
    await apolloClient.mutate({
      mutation: require('./api/markFeatureToursSeen.graphql'),
      variables: { ids },
    });
  } catch (error) {
    console.debug('Failed to mark feature tours as seen:', error.message);
  }
}
